import { render, staticRenderFns } from "./DreceiptIndex.vue?vue&type=template&id=0b905e38&scoped=true"
import script from "./DreceiptIndex.vue?vue&type=script&lang=js"
export * from "./DreceiptIndex.vue?vue&type=script&lang=js"
import style0 from "./DreceiptIndex.vue?vue&type=style&index=0&id=0b905e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b905e38",
  null
  
)

export default component.exports